var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.371819 2.16662L3.70475 5.49992L0.371819 8.83307C-0.123939 9.32902 -0.123939 10.1324 0.371819 10.6283C0.619524 10.8761 0.944281 11 1.26888 11C1.59402 11 1.91881 10.8762 2.16632 10.6283L5.49998 7.29482L8.83339 10.6283C9.08107 10.876 9.40586 11 9.73074 11C10.0555 11 10.3801 10.8762 10.628 10.6283C11.1237 10.1326 11.1237 9.32918 10.628 8.83304L7.29515 5.49989L10.6282 2.16662C11.1239 1.67086 11.1239 0.867297 10.6282 0.371536C10.1325 -0.123845 9.32944 -0.123845 8.83358 0.371536L5.50002 3.70484L2.1667 0.371536C1.67075 -0.123845 0.867576 -0.123845 0.372008 0.371536C-0.123939 0.867297 -0.123939 1.67086 0.371819 2.16662Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.87e7d3a02977ef71ba02d739d360da95.svg";
export { ForwardRef as ReactComponent };